import CompanySdk from '@nackle/company-sdk';
import { companyServiceUrl } from 'endpoints';
import fetch from '../utils/fetch';

export default new CompanySdk( companyServiceUrl, fetch );